import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { getSpecificUser } from "../../../../redux/features/Settings/Management/Users";
import ICONS from "../../../../assets/Icons";

const UserEditContactSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  const { specificUserData } = useSelector((state) => state.users);
  const user = specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero];

  useEffect(() => {
    const fetchUser = async () => {
      setIsLoading(true);
      const response = await dispatch(getSpecificUser(id));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
        return;
      }
      setIsLoading(false);
    };
    fetchUser();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const formatName = (first, last) => {
    const full = [first, last].filter(Boolean).join(" ").trim();
    return full
      ? full
          .toLowerCase()
          .split(" ")
          .map(
            (word) =>
              word.charAt(GlobalConfiguration.lengthCheckZero).toUpperCase() +
              word.slice(GlobalConfiguration.lengthCheckOne),
          )
          .join(" ")
      : "—";
  };

  const buttonRows = [
    [
      {
        btnText: "Create new user",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON_WHITE,
        handleFunction: () => navigate("/settings/users/create_user"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: () => {
          navigate(`/settings/user_view_all/user_detail_page/${id}`);
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/home"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  return (
    <StatusContainer
      isLoading={isLoading}
      status="success"
      hoverOption="white"
      title={"User’s details updated successfully."}
      buttonRows={buttonRows}
    >
      <TabsWeapperSection title="User details">
        <>
          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: formatName(user?.first_name, user?.last_name),
                leftSubTitle: "User name",
              },
            ]}
          />
          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: user?.user_id || user?.identifier || user?.user_name,
                leftSubTitle: "User ID",
              },
            ]}
          />
          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: user?.alias_name || "N/A",
                leftSubTitle: "Alias",
              },
            ]}
          />
          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: user?.mob_no,
                leftSubTitle: "Contact number",
              },
            ]}
          />
          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: user?.email_id,
                leftSubTitle: "Email ID",
              },
            ]}
          />
          <InfoCard
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: user?.grade,
                leftSubTitle: "Grade",
              },
            ]}
          />
        </>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default UserEditContactSuccess;
